import MyCourses from '@/components/myCourses/MyCourses'
import MyCoursesList from '@/components/myCourses/MyCoursesList'
import TableOfContents from '@/components/myCourses/TableOfContents'
import MyTaskList from '@/components/myCourses/MyTaskList'
import TaskView from '@/components/myCourses/TaskView'

export default [
  {
    path: '/my-courses',
    component: MyCourses,
    children: [
      {path: '', component: MyCoursesList},
      {path: 'course-view', component: TableOfContents},
      {path: 'course-view/my-tasks', component: MyTaskList},
      {path: 'course-view/my-tasks/task-view', component: TaskView}
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/myCourses/routes.js